<!-- Container-fluid starts-->
<div class="container-fluid reports-not-assigned-page">
  <div class="reports-page-header">
    <div>
      <h4 class="mb-1">Reportes sin turnar</h4>
      <small class="text-muted">Consulta y asignación de reportes pendientes de dependencia</small>
      <div class="reports-status-filters mt-2">
        <button type="button" class="btn btn-sm report-status-filter active">
          Total <span>({{total || 0}})</span>
        </button>
      </div>
    </div>
    <div class="reports-header-actions">
      <button
        class="btn btn-primary1 btn-report-primary"
        (click)="exportExcel()"
        [disabled]="isLoading">
        <i class="fa fa-download" *ngIf="!isLoading" aria-hidden="true"></i>
        {{ isLoading ? 'Exportando' : 'Exportar a Excel'}}
        <i class="fa fa-spinner fa-spin" *ngIf="isLoading" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <div class="row pl-3 reports-turnados-toolbar">
    <div class="row col-12 mb-4 mt-3 reports-filter-row">
      <div class="col-xl-5 col-xs-12 pl-0">
        <div class="form-group mb-0">
          <input
            placeholder="Buscar por folio, nombre, correo o teléfono"
            class="form-control"
            type="text"
            [(ngModel)]="textSearch"
            (keyup.enter)="getResults()">
        </div>
      </div>
      <div class="col-xl-5 col-xs-12 reports-filter-actions">
        <button class="btn btn-primary1 btn-report-search" (click)="getResults()">
          <i class="fa fa-search" aria-hidden="true"></i>
          Filtrar
        </button>
        <button title="Borrar filtros" class="btn btn-report-secondary btn-report-clear" (click)="clearInputs()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <div class="col-xl-2 col-xs-12 pr-0">
        <div class="btn-popup pull-right">
          <button [routerLink]="['/reports/create-report']" [queryParams]="{ returnTo: 'not-assigned' }" class="btn btn-primary1 btn-report-create">
            <i class="fa fa-plus" aria-hidden="true"></i>
            Crear reporte
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
      <div class="card-body">
      <div id="batchDelete" class="">
          <div class="table-responsive">
              <table datatable
              [dtOptions]="dtOptions"
              [dtTrigger]="dtTrigger"
              class=" table table-lg table-hover row-border hover">
              <thead>
                  <tr>
                      <th>Nº</th>
                      <th>Folio</th>
                      <!-- <th>Tiempo en espera</th> -->
                      <th>Reporte</th>
                      <th>Ciudadano</th>
                      <th>Colonia</th>
                      <th>Status</th>
                      <th>Fecha de reporte</th>
                      <th>Fuente</th>
                      <th>Opciones</th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let report of reports?.List; let i = index">
                      <td>{{((page - 1) * limit) + i + 1}}</td>
                      <td>
                        <div class="report-folio-cell">
                          <strong>{{report.folio}}</strong>
                        </div>
                      </td>
                      <!-- <td>{{report.timeTranscured}} horas</td> -->
                      <td>
                        <div class="report-subject-cell">
                          <strong>{{report.Subject || 'Sin asunto'}}</strong>
                          <span>
                            <i class="fa fa-building" aria-hidden="true"></i>
                            {{report.Department ? report.Department : 'Sin área asignada'}}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="report-citizen-cell">
                          <strong>{{report.Name || 'Sin nombre'}}</strong>
                          <span>
                            <i class="fa fa-envelope" aria-hidden="true"></i>
                            {{report.Email || 'Sin correo'}}
                          </span>
                          <span>
                            <i class="fa fa-phone" aria-hidden="true"></i>
                            {{report.PhoneNumber || 'Sin teléfono'}}
                          </span>
                        </div>
                      </td>
                      <td>{{report.Address?.Neighborhood ? report.Address.Neighborhood : 'Sin colonia'}}</td>
                      <td>{{report.Status}}</td>
                      <td>{{report.created_at | date:'dd/MM/yyyy'}}</td>
                      <td>{{report.Source ?  report.Source : 'Invitado'}}</td>
                      <td class="overflow-hidden text-center">
                        <div class="reports-row-actions">
                          <button class="btn btn-sm btn-report-icon-action btn-report-view-action" [routerLink]="['show', report.id]" title="Ver reporte">
                            <i class="fa fa-eye" aria-hidden="true"></i>
                          </button>
                          <button class="btn btn-sm btn-report-icon-action btn-report-edit-action" [routerLink]="['edit', report.id]" title="Editar reporte">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                          </button>
                          <button class="btn btn-sm btn-report-icon-action btn-report-assign-action" (click)="assignModalContent(contentArea, report.id)" title="Turnar reporte">
                            <i class="fa fa-share" aria-hidden="true"></i>
                          </button>
                        </div>
                      </td>
                  </tr>
              </tbody>
              </table>
              <div class="row reports-pagination-row">
                <div class="col-12 col-md-4 m-auto reports-pagination-summary">
                  Mostrando {{getRangeStart()}} - {{getRangeEnd()}} de {{total || 0}}
                </div> 
                <div class="col-12 col-md-8 reports-pagination-control">
                  <ngb-pagination
                    (pageChange)="loadPage($event)"
                    [collectionSize]="total"
                    [(page)]="page"
                    [pageSize]="limit"
                    [maxSize]="10"
                    [rotate]="true"
                    [boundaryLinks]="true">
                  </ngb-pagination>
                </div> 
              </div>
          </div>
          <table
              class="table table-lg table-hover row-border hover d-none"
              id="reports-general">
              <thead>
                  <tr>
                      <th>No</th>
                      <th>FOLIO</th>
                      <th>ASUNTO</th>
                      <th>DESCRIPCIÓN</th>
                      <th>DEPENDENCIA</th>
                      <th>NOMBRE</th>
                      <th>COLONIA</th>
                      <th>UBICACIÓN</th>
                      <th>ENTRE CALLES</th>
                      <th>STATUS</th>
                      <th>FECHA DE CREADO</th>
                      <th>FECHA DE ATENDIDO</th>
                      <th>MODO DE CAPTURA</th>
                      <th>TELÉFONO / CELULAR</th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let report of allReports?.List; let i = index">
                      <td>{{i+1}}</td>
                      <td>{{report.folio}}</td>
                      <td>{{report.Subject}}</td>
                      <td>{{report.Description}}</td>
                      <td>{{report.Department ? report.Department : 'Sin área asignada'}}</td>
                      <td>{{report.Name}}</td>
                      <td>{{report.Address?.Neighborhood ? report.Address.Neighborhood : 'N/A'}}</td>
                      <td>{{report.Address ? report.Address.Street + ' ' + report.Address.ExtNumber + ' ' + report.Address.Neighborhood + ' ' + report.Address.State + ' ' + report.Address.ZipCode : 'N/A'}}</td>
                      <td>{{report.Address?.Street1 ? report.Address.Street1 + ' y ' + report.Address.Street2 : 'N/A'}}</td>
                      <td>{{report.Status}}</td>
                      <td>{{report.created_at | date: 'dd/MM/yyyy'}}</td>
                      <td>{{report.ClosedAt | date: 'dd/MM/yyyy'}}</td>
                      <td>{{report.Source ? report.Source : 'Invitado'}}</td>
                      <td>{{report.PhoneNumber ? report.PhoneNumber : 'Sin número'}}</td>
                  </tr>
              </tbody>
          </table>
      </div>
      </div>
  </div>
  </div>
  <!-- Container-fluid Ends-->

<!-- Assign report -->
<ng-template #contentArea
  let-modal>
  <div class="modal-header report-modal-header">
    <div class="report-modal-title">
      <span class="report-modal-icon report-modal-icon--info">
        <i class="fa fa-share" aria-hidden="true"></i>
      </span>
      <div>
        <h4 class="modal-title" id="modal-title">Turnar reporte</h4>
        <p>Selecciona el área responsable para atenderlo.</p>
      </div>
    </div>
    <button type="button" class="report-modal-close" aria-label="Cerrar" (click)="modal.dismiss()">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>
  <div class="modal-body report-modal-body">
    <ng-container *ngIf="!assignIsSuccess">
      <p class="no-mrg">Por favor selecciona el área a la que se asignará el reporte.</p>
      <div class="col-xs-12 col-md-12 mt-2">
        <div class="form-group">
            <ng-select [(ngModel)]="area">
                <ng-option value="" disabled selected>Área</ng-option>
                <ng-option *ngFor="let value of values" [value]="value">
                    {{value}}
                </ng-option>
            </ng-select>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="assignIsSuccess">
      <p>Reporte asignado correctamente</p>
    </ng-container>
  </div>
  <ng-container *ngIf="!assignIsSuccess">
    <div class="modal-footer report-modal-footer">
      <a type="button"
        class="btn btn-report-cancel"
        (click)="modal.close()">Cancelar</a>
      <button 
        class="btn btn-report-primary"
        (click)="assignReport()">
        <i class="fa fa-share" aria-hidden="true"></i>
        Asignar
      </button>
    </div>
  </ng-container>
</ng-template>


<ng-template #contentDelete
  let-modal>
  <div class="modal-header report-modal-header">
    <div class="report-modal-title">
      <span class="report-modal-icon report-modal-icon--danger">
        <i class="fa fa-trash" aria-hidden="true"></i>
      </span>
      <div>
        <h4 class="modal-title" id="modal-title">Eliminar reporte</h4>
        <p>Confirma que deseas eliminar este registro.</p>
      </div>
    </div>
    <button type="button" class="report-modal-close" aria-label="Cerrar" (click)="modal.dismiss()">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>
  <div class="modal-body report-modal-body">
    <ng-container *ngIf="!deleteIsSuccess">
      <p class="no-mrg">Se eliminirán todos los datos del reporte.</p>
      <p class="no-mrg">Esta acción no se puede deshacer.</p>
    </ng-container>

    <ng-container *ngIf="deleteIsSuccess">
      <p>Reporte eliminado correctamente</p>
    </ng-container>
  </div>
  <ng-container *ngIf="!deleteIsSuccess">
    <div class="modal-footer report-modal-footer">
      <a type="button"
        class="btn btn-report-cancel"
        (click)="modal.close()">Cancelar</a>
      <button type="button"
        class="btn btn-report-danger"
        (click)="eliminarReporte()">
        <i class="fa fa-trash" aria-hidden="true"></i>
        Eliminar
      </button>
    </div>
  </ng-container>
</ng-template>
